angular.module("admin").controller(
  "AdminCtrl",

  function ($state, UserManager, config, $uibModal) {
    this.site = config.site;
    UserManager.getCurrent().then(
      (session) => {
        this.currentUser = session;
      },
      () => {
        $state.go("login");
      }
    );

    this.getInitials = function (name) {
      if (!name) return "";

      const parts = name.trim().split(/\s+/);

      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      }

      return parts[0][0].toUpperCase();
    };

    this.changePassword = function () {
      $uibModal.open({
        templateUrl: "views/admin/changepassword.html",
        controller: "ChangePasswordCtrl",
        controllerAs: "ctrl",
      });
    };

    this.quickSearch = function () {
      $state.go("admin.subscriptionDetails", {
        subscriptionNumber: this.quickSub.number,
      });
      delete this.quickSub.number;
    };
  }
);
